import { render, staticRenderFns } from "./BlockedGallery.vue?vue&type=template&id=2f4b8b32&scoped=true"
import script from "./BlockedGallery.vue?vue&type=script&lang=js"
export * from "./BlockedGallery.vue?vue&type=script&lang=js"
import style0 from "./BlockedGallery.vue?vue&type=style&index=0&id=2f4b8b32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b8b32",
  null
  
)

export default component.exports